import TranslationNS from '@/utils/Constants/TranslationNS'

/**
 * Check-in — `check-in-athletes`, `check-in-volunteers`, `check-in-spectators`, one tour for the
 * three audiences: the page, the filters, the ticket scanner (spectators only), the state counters,
 * the list header, then the first row and everything it holds (state buttons, contract, order link,
 * extra products).
 */
export const CHECK_IN_TOUR = {
    id: 'check-in',
    version: 1,
    paths: ['check-in-athletes', 'check-in-volunteers', 'check-in-spectators'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Tick off arrivals',
            description: 'On the day, record here who has arrived: athletes, volunteers or spectators.',
        },
        {
            key: 'filters',
            target: '[data-tour="checkin-filters"]',
            placement: 'bottom',
            title: 'Find a person',
            description:
                'Type a name, or filter by category, state or passage time to get there faster. « Reset filters » clears everything.',
        },
        {
            key: 'scan',
            target: '[data-tour="checkin-scan"]',
            placement: 'bottom',
            title: 'Scan the tickets',
            description: 'For spectators, scan the QR code of the ticket: its row shows up at once.',
        },
        {
            key: 'states',
            target: '[data-tour="checkin-states"]',
            placement: 'bottom',
            title: 'Follow the counts',
            description: 'How many people are expected, arrived or absent. One click filters the list.',
        },
        {
            key: 'list',
            // the table's header row: the table itself is taller than the screen on a big event
            target: '[data-tour="checkin-list"]',
            block: '.ant-table-thead',
            placement: 'bottom',
            title: 'The list',
            description: 'One row per registrant, sorted by the column you click.',
        },
        {
            key: 'row',
            target: '[data-tour="checkin-list"] .ant-table-tbody tr.ant-table-row',
            scroll: 'start',
            placement: 'bottom',
            title: 'Mark the arrival',
            description: 'Everything about one person sits on its row:',
            entries: [
                {
                    label: 'Who it is',
                    text: 'name or team, category, passage times — or ticket and buyer for spectators.',
                },
                {
                    label: 'The state buttons',
                    text: 'expected, arrived or absent: one tap changes the state, saved at once.',
                },
                {
                    label: 'Contract signed x / y',
                    text: 'athletes only: red until every member of the team has signed.',
                },
                { label: 'Edit', ns: TranslationNS.CHECKIN, text: 'opens the order in a new tab to correct it.' },
                { label: 'The arrow', text: 'unfolds the extra products ordered, to hand them over.' },
            ],
        },
    ],
}

export default CHECK_IN_TOUR
